import { render, staticRenderFns } from "./DetailHeader.vue?vue&type=template&id=5bb772fc&scoped=true"
import script from "./DetailHeader.vue?vue&type=script&lang=js"
export * from "./DetailHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb772fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qjsz/develop/project/cc-shop-new/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bb772fc')) {
      api.createRecord('5bb772fc', component.options)
    } else {
      api.reload('5bb772fc', component.options)
    }
    module.hot.accept("./DetailHeader.vue?vue&type=template&id=5bb772fc&scoped=true", function () {
      api.rerender('5bb772fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/DetailHeader.vue"
export default component.exports